export type PlayerInfo = {
  name: string;
  userId: string;
  image: string;
  frame: string | null;
  avatarRarity: string | null;
  factionRank: string | undefined;
  wins: number | undefined;
};

export function getTopPlayerListFromFaction(
  faction: any,
  playersType: 'active' | 'strongest'
): PlayerInfo[] {
  if (faction && playersType === 'active') {
    return [
      {
        name: faction['1st_active_player'],
        userId: faction['1st_active_player_user_id'],
        image: faction['1st_active_player_img'],
        frame: faction['1st_active_player_frame'],
        avatarRarity: faction['1st_active_player_img_rarity'],
        factionRank: faction['1st_active_player_alliance_rank'],
        wins: faction['1st_active_player_last_30d_wins'],
      },
      {
        name: faction['2nd_active_player'],
        userId: faction['2nd_active_player_user_id'],
        image: faction['2nd_active_player_img'],
        frame: faction['2nd_active_player_frame'],
        avatarRarity: faction['2nd_active_player_img_rarity'],
        factionRank: faction['2nd_active_player_alliance_rank'],
        wins: faction['2nd_active_player_last_30d_wins'],
      },
      {
        name: faction['3rd_active_player'],
        userId: faction['3rd_active_player_user_id'],
        image: faction['3rd_active_player_img'],
        frame: faction['3rd_active_player_frame'],
        avatarRarity: faction['3rd_active_player_img_rarity'],
        factionRank: faction['3rd_active_player_alliance_rank'],
        wins: faction['3rd_active_player_last_30d_wins'],
      },
      {
        name: faction['4th_active_player'],
        userId: faction['4th_active_player_user_id'],
        image: faction['4th_active_player_img'],
        frame: faction['4th_active_player_frame'],
        avatarRarity: faction['4th_active_player_img_rarity'],
        factionRank: faction['4th_active_player_alliance_rank'],
        wins: faction['4th_active_player_last_30d_wins'],
      },
      {
        name: faction['5th_active_player'],
        userId: faction['5th_active_player_user_id'],
        image: faction['5th_active_player_img'],
        frame: faction['5th_active_player_frame'],
        avatarRarity: faction['5th_active_player_img_rarity'],
        factionRank: faction['5th_active_player_alliance_rank'],
        wins: faction['5th_active_player_last_30d_wins'],
      },
    ];
  } else if (faction && playersType === 'strongest') {
    return [
      {
        name: faction['1st_strongest_player'],
        userId: faction['1st_strongest_player_user_id'],
        image: faction['1st_strongest_player_img'],
        frame: faction['1st_strongest_player_frame'],
        avatarRarity: faction['1st_strongest_player_img_rarity'],
        factionRank: faction['1st_strongest_player_alliance_rank'],
        wins: faction['1st_strongest_player_total_roster_talent'],
      },
      {
        name: faction['2nd_strongest_player'],
        userId: faction['2nd_strongest_player_user_id'],
        image: faction['2nd_strongest_player_img'],
        frame: faction['2nd_strongest_player_frame'],
        avatarRarity: faction['2nd_strongest_player_img_rarity'],
        factionRank: faction['2nd_strongest_player_alliance_rank'],
        wins: faction['2nd_strongest_player_total_roster_talent'],
      },
      {
        name: faction['3rd_strongest_player'],
        userId: faction['3rd_strongest_player_user_id'],
        image: faction['3rd_strongest_player_img'],
        frame: faction['3rd_strongest_player_frame'],
        avatarRarity: faction['3rd_strongest_player_img_rarity'],
        factionRank: faction['3rd_strongest_player_alliance_rank'],
        wins: faction['3rd_strongest_player_total_roster_talent'],
      },
      {
        name: faction['4th_strongest_player'],
        userId: faction['4th_strongest_player_user_id'],
        image: faction['4th_strongest_player_img'],
        frame: faction['4th_strongest_player_frame'],
        avatarRarity: faction['4th_strongest_player_img_rarity'],
        factionRank: faction['4th_strongest_player_alliance_rank'],
        wins: faction['4th_strongest_player_total_roster_talent'],
      },
      {
        name: faction['5th_strongest_player'],
        userId: faction['5th_strongest_player_user_id'],
        image: faction['5th_strongest_player_img'],
        frame: faction['5th_strongest_player_frame'],
        avatarRarity: faction['5th_strongest_player_img_rarity'],
        factionRank: faction['5th_strongest_player_alliance_rank'],
        wins: faction['5th_strongest_player_total_roster_talent'],
      },
    ];
  } else {
    return [];
  }
}
